import { useContext } from 'react';
import { PatientContextType } from '../types/types';
import { PatientContext } from '../PatientContext';

export const usePatientContext = (): PatientContextType => {
  const ctx = useContext(PatientContext);
  if (!ctx) {
    throw new Error('usePatientContext must be used within a PatientProvider');
  }
  return ctx;
};
